import { APIError } from '../models'
import APIService from './APIService'

/**
 * Service fetching current service configuration from API.
 */
class ShareLinkService {
  /**
   * Check if localStorage contains a prize for joining via shared link.
   * If so, try to consume the prize.
   */
  static async checkSharePrice(): Promise<void> {
    const surveyId = localStorage.getItem('sharLinkPr')
    if (!surveyId) {
      return
    }

    const response = await APIService.post('/share_prizes', '', {
      survey_id: surveyId,
    })
    if (response instanceof APIError) {
      return
    }
  }
}

export default ShareLinkService
